import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: "select-workstream-item",
  templateUrl: 'select-workstream-item.component.html',
  styleUrls: ['./select-workstream-item.component.scss'],
})
export class SelectWorkstreamItemComponent {
  cols : any[] = [
    { name: 'Workstream', field: 'workstreamName' },
    { name: 'Name', field: 'wsid' },
    { name: 'Key Criteria', field: 'keyCriteria' }
  ]
  workstreamItems: any[] = [];
  rowGroupIndexes: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SelectWorkstreamItemComponent>) {
    let i = 0;
    for (let workstream of data.workstreams) {
      this.rowGroupIndexes[workstream.workstreamId] = i;
      for (let item of workstream.workstreamItems) {
        this.workstreamItems.push(item);
        i++;
      }
    }
  }

  select(data)
  {
    this.dialogRef.close(data);
  }
}
